export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/about-afbb6eb78b63734079c5d59b80416cd1.png";